//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import { mapGetters } from "vuex";
  import PcAside from "@/pccomponents/aside"
  import PcHeader from "@/pccomponents/Header"
  import PageTabs from "@/pccomponents/PageTabs"
    export default {
      name: "layout",
      components: {
        PcAside,
        PcHeader,
        PageTabs
      },
      data() {
        return {
          isRouterAlive: true,
          mainContentObj: {},
          mainContentObj_scrollH: 0, // 记录上一次 mainContent 的内容高度
          sideWidth: '220px',
          showmenu:true,
          fullscreenloading: false
        }
      },
      computed: {
        sidebarOpened() {
          if(this.showmenu == false){
            return true;
          }else{
            return this.$store.state.sidebarOpened;
          }
				},
				loadingState() {
					return this.$store.state.loadingState;
				},
        key() {
            return this.$store.state.timestamp;
        }
      },
      mounted(){
        // 显示页面tab
				this.addPageTab();
				// 菜单可拖拽
				this.dragMenu();

        //测试——判断前端登录状态标识
       console.log("loginstatus"+window.sessionStorage.getItem('loginedStatus'));

        // if(window.sessionStorage.getItem('loginedStatus') === null){
        //   this.$router.replace({ path: '/login'})
        // }

        this.mainContentObj = this.$children[0].$children[1].$children[1].$children[0].$refs.mainContent || {};
        if (JSON.stringify(this.mainContentObj) !== "{}" && typeof this.mainContentObj === "object") {
            // this.setMainContentHeight(this.mainContentObj);
            // window.onresize = () => {
            //     this.setMainContentHeight(this.mainContentObj);
            // }

            this.mainContentObj_scrollH = this.mainContentObj.scrollHeight;
        }
        
      },
      updated() {
        // 显示页面tab
				this.addPageTab();
				
				// 设置面包屑导航条位置（菜单可拖拽时设置）
        let topOpteration = document.getElementsByClassName("topOpteration")[0];
        topOpteration.style.left = this.sideWidth;
      },
      provide() {
        return {
          reload: this.reload
        }
      },
      created(){
         //门户过来则隐藏菜单信息
         let portalflag = this.$route.query.portalflag;
         
         if(portalflag == 'portal'){

            this.showmenu = false;
          }

          window.addEventListener('setItem',()=>{
             let aa = window.sessionStorage.getItem('loginedStatus');
             console.log("aaaaaaaaaaa"+aa);
             this.tipSuccess(aa);
          });
      },
      methods: {
        reload() {
          this.isRouterAlive = false
          this.$nextTick(function() {
            this.isRouterAlive = true
          })
        },
        // 添加页面tab
        addPageTab() {
          const item = this.$route;
          const routeName = this.$t(item.name);
          const label = routeName,
              name = routeName,
              path = item.fullPath;

          this.$store.dispatch("addPageTab", {
              name: name,
              label: label,
              path: path
          });
          this.$store.dispatch("changePageTabValue", name);
				},
				dragMenu() {
					if(this.$refs.rightDragBar) {
						this.$refs.rightDragBar.onmousedown = (e) => {
							e.draggable = false;
							let disX = e.pageX;
							document.onmousemove = (e) => {
								if(e.pageX > 500) {
										disX = 500;
								} else if(e.pageX < 220) {
										disX = 220;
								} else {
										disX = e.pageX;
								}
								this.sideWidth = disX + "px";
								document.body.style.cursor = "e-resize"
							}
							document.onmouseup = () => {
								document.onmousemove = null;
								document.onmouseup = null;
								document.body.style.cursor = "initial"
							};
						}
					}
				}
			},
    }



// WEBPACK FOOTER //
// ./src/layout/Layout.vue